import R from 'ramda';
import actionTypes from '../actionTypes';

const initialState = {
  deals: [],
  dealChanges: [],
  finalizedDeals: [],
};

export default (state = initialState, action) => {
  let index;

  switch (action.type) {
    case actionTypes.DEALS_GET_REQUEST:
    case actionTypes.DEAL_GET_REQUEST:
    case actionTypes.DEAL_CREATE_REQUEST:
    case actionTypes.DEAL_UPDATE_REQUEST:
    case actionTypes.DEALS_USER_GET_REQUEST:
    case actionTypes.FINALIZED_DEALS_GET_REQUEST:
      return { ...state, status: action.type };

    case actionTypes.DEALS_GET_ERROR:
    case actionTypes.DEALS_USER_GET_ERROR:
      return { ...initialState };

    case actionTypes.DEALS_GET_SUCCESS:
    case actionTypes.DEALS_USER_GET_SUCCESS:
      return { ...state, status: action.type, deals: action.deals };

    case actionTypes.DEAL_GET_ERROR:
    case actionTypes.DEAL_CREATE_ERROR:
      return {
        ...state,
        status: action.type,
        error: action.error,
        selectedDeal: null,
      };

    case actionTypes.DEAL_GET_SUCCESS:
    case actionTypes.DEAL_SELECT:
      return { ...state, status: action.type, selectedDeal: action.deal };

    case actionTypes.INVITE_GET_BY_KEY_SUCCESS:
      return { ...state, status: '', selectedDeal: action.invite.deal_info };

    case actionTypes.DEAL_CREATE_SUCCESS:
      return {
        ...state,
        status: action.type,
        selectedDeal: action.deal,
        deals: state.deals.concat(action.deal),
      };

    case actionTypes.DEAL_UPDATE_SUCCESS:
      index = R.findIndex(R.propEq('id', action.deal.id))(state.deals);
      if (index === -1) {
        return {
          ...state,
          status: action.type,
          selectedDeal: action.deal,
          deals: state.deals.concat(action.deal),
        };
      } else {
        state.deals[index] = action.deal;
        return {
          ...state,
          status: action.type,
          selectedDeal: action.deal,
          deals: [...state.deals],
        };
      }

    case actionTypes.DEAL_DELETE_SUCCESS:
      index = R.findIndex(R.propEq('id', parseInt(action.dealId, 10)))(
        state.deals
      );

      if (index !== -1) {
        return {
          ...state,
          status: action.type,
          selectedDeal: null,
          deals: R.remove(index, 1, state.deals),
        };
      } else {
        return { ...state, status: action.type, selectedDeal: null };
      }

    case actionTypes.DEAL_CHANGE_GET_REQUEST:
    case actionTypes.DEAL_CHANGE_CREATE_REQUEST:
    case actionTypes.DEAL_CHANGE_UPDATE_REQUEST:
    case actionTypes.DEAL_CHANGE_DELETE_REQUEST:
      return { ...state, status: action.type };

    case actionTypes.DEAL_CHANGES_GET_ERROR:
      return { ...state, status: action.type, dealChanges: [] };

    case actionTypes.DEAL_CHANGES_GET_SUCCESS:
      return { ...state, status: action.type, dealChanges: action.dealChanges };

    case actionTypes.DEAL_CHANGE_GET_ERROR:
    case actionTypes.DEAL_CHANGE_CREATE_ERROR:
      return {
        ...state,
        status: action.type,
        error: action.error,
        selectedDealChange: null,
      };

    case actionTypes.DEAL_CHANGE_GET_SUCCESS:
      return {
        ...state,
        status: action.type,
        selectedDealChange: action.dealChange,
      };

    case actionTypes.DEAL_CHANGE_CREATE_SUCCESS:
      return {
        ...state,
        status: action.type,
        selectedDealChange: action.dealChange,
        dealChanges: state.dealChanges.concat(action.dealChange),
      };

    case actionTypes.DEAL_CHANGE_DELETE_SUCCESS:
      index = R.findIndex(R.propEq('id', parseInt(action.dealChangeId, 10)))(
        state.dealChanges
      );
      if (index !== -1) {
        return {
          ...state,
          status: action.type,
          selectedDealChange: null,
          dealChanges: R.remove(index, 1, state.dealChanges),
        };
      } else {
        return { ...state, status: action.type, selectedDealChange: null };
      }

    case actionTypes.DEAL_CHANGE_UPDATE_SUCCESS:
      index = R.findIndex(R.propEq('id', parseInt(action.dealChange.id, 10)))(
        state.dealChanges
      );
      if (index === -1) {
        return {
          ...state,
          status: action.type,
          selectedDealChange: null,
          dealChanges: state.dealChanges.concat(action.dealChange),
        };
      } else {
        state.dealChanges[index] = action.dealChange;
        return {
          ...state,
          status: action.type,
          selectedDealChange: null,
          dealChanges: state.dealChanges.concat(),
        };
      }

    case actionTypes.FINALIZED_DEALS_GET_ERROR:
      return { ...state, status: action.type, finalizedDeals: [] };

    case actionTypes.FINALIZED_DEALS_GET_SUCCESS:
      return {
        ...state,
        status: action.type,
        finalizedDeals: action.finalizedDeals,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/redux/reducers/deals.js